import { render, staticRenderFns } from "./EditReason.vue?vue&type=template&id=15c76fa6&scoped=true&"
import script from "./EditReason.vue?vue&type=script&lang=js&"
export * from "./EditReason.vue?vue&type=script&lang=js&"
import style0 from "./EditReason.vue?vue&type=style&index=0&id=15c76fa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c76fa6",
  null
  
)

export default component.exports